import { Box, Button } from '@mui/material'
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

import FieldImport from 'components/field-import'

import FileUploadInput from 'components/cff/upload-boundaries/fileUploadInput'
import { useSelector } from 'react-redux'

import { type AppState } from 'state/index'

import { getClientFarm } from 'common/misc'
import colors from 'common/colors'

interface UploadBoundariesProps {
  onImportField: (files: FileList) => void
  isTransferringData: boolean
  setTransferringData: (value: boolean) => void
}

export default function UploadBoundariesComponent(
  props: UploadBoundariesProps,
) {
  const { t } = useTranslation()
  const { onImportField, isTransferringData, setTransferringData } = props

  const clients = useSelector(
    (state: AppState) => state.client.collection || [],
  )

  const cffEnabled = useSelector(
    (state: AppState) => state.account.singleton.prefs?.cff?.enabled ?? false,
  )
  const prefDefault = useSelector(
    (state: AppState) => state.account.singleton.prefs?.cff?.client ?? '',
  )

  const prefDefaultFarm = useSelector(
    (state: AppState) => state.account.singleton.prefs?.cff?.farm,
  )
  const { client, farms } = getClientFarm(cffEnabled, clients, prefDefault)

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100vw',
        minWidth: 0,
        p: 1,
      }}
    >
      <Box
        sx={{ flex: '0 0 auto', boxShadow: 'none', background: colors.white }}
      >
        <h2 style={{ color: 'black', margin: '8px' }}>
          {t('upload_boundaries')}
        </h2>
        <Button startIcon={<InfoOutlinedIcon />} color="success">
          {t('valid_fields_polygons_import')}
        </Button>
        <Button startIcon={<InfoOutlinedIcon />} color="success">
          {t('create_client_farm')}
        </Button>
      </Box>
      <FieldImport
        onImportField={onImportField}
        defaultClient={client}
        defaultFarm={farms[0]}
        clients={clients}
        fileUpload={FileUploadInput}
        isTransferringData={isTransferringData}
        setTransferringData={setTransferringData}
      />
    </Box>
  )
}
